import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';

interface IPageHeader {
  icon: string;
  iconBackCommands?: (string | number)[] | null;
  showFilterButton?: boolean;
  showFilterCard?: boolean;
  subtitle?: string;
  title: string;
}

@Injectable({
  providedIn: 'root',
})
export class PageHeaderService {
  constructor(private readonly titleService: Title) {}

  public static headerSetByPage = new BehaviorSubject<Partial<IPageHeader>>({ icon: '', title: '' });
  public static headerSetByPage$ = PageHeaderService.headerSetByPage.asObservable();

  public static setPageHeader(pageHeader: Partial<IPageHeader>): void {
    PageHeaderService.headerSetByPage.next(pageHeader);
  }

  public setTitle(name: string): void {
    this.titleService.setTitle(`${name} | Digital Boards`);
  }
}
